module.exports = __webpack_public_path__ + "static/media/p8.21ff26c4.png";